import { useQuery } from "@apollo/client/react";
import type {
  LookupCompanyFilter,
  LookupCompanyResult,
} from "../queries/getLookupCompany";
import GET_LOOKUP_COMPANY from "../queries/getLookupCompany";

export const useLookup = (lookupFilters?: LookupCompanyFilter) => {
  const shouldSkip =
    !lookupFilters?.searchTerm || lookupFilters.searchTerm.length < 2;

  const { data, error, loading, previousData, refetch } =
    useQuery<LookupCompanyResult>(GET_LOOKUP_COMPANY, {
      variables: {
        sortDirection: lookupFilters?.sortDirection,
        sortBy: lookupFilters?.sortBy,
        searchTerm: lookupFilters?.searchTerm ?? "",
        isIssuer: lookupFilters?.isIssuer,
        isRecipient: lookupFilters?.isRecipient,
        skip: lookupFilters?.skip ?? 0,
        take: lookupFilters?.take ?? 20,
      },
      skip: shouldSkip,
      notifyOnNetworkStatusChange: true,
    });
  return { lookup: data?.lookup, error, loading, previousData, refetch };
};
